import React, { useState, useEffect } from 'react'
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

function Reportmenu() {
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);
    const [username, setusername] = useState("");



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData1()
        });
    });

    const fetchData1 = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    return (
        <div>
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                {/* Brand Logo */}
                <a href="#0" className="brand-link">
                    <img src={window.location.origin + '/user.jpg'} alt="A" className="brand-image img-circle elevation-3" style={{ opacity: '.8' }} />
                    <span className="brand-text font-weight-light">{username} </span>
                </a>
                <div className="sidebar">
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

                            <li className="nav-header" style={{ fontWeight: "700" }}>Report</li>
                            <li className="nav-item">
                                <a href="/daily-report" className="nav-link">
                                    <i className="nav-icon fa fa-file" />
                                    <p>Receptionist Report</p>
                                </a>
                            </li>
                            {/* <li className="nav-item">
                                <a href="/booking-report" className="nav-link">
                                    <i className="nav-icon fa fa-file" />
                                    <p> Booking Report</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/room-type-wise-online-bookings" className="nav-link">
                                    <i className="nav-icon fa fa-file" />
                                    <p>Room Type Wise Online </p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/customerwise-report" className="nav-link">
                                    <i className="nav-icon fa fa-file" />
                                    <p>Customerwise Report </p>
                                </a>
                            </li> */}
                            <li className="nav-item">
                                <a href="/checkout-alert" className="nav-link">
                                    <i className="nav-icon fa fa-file" />
                                    <p>Checkout Alert</p>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="/back-date-report" className="nav-link">
                                    <i className="nav-icon fa fa-file" />
                                    <p>Back Date Report</p>
                                </a>
                            </li>
                            {/* <li className="nav-item">
                                <a href="/room-cleaned" className="nav-link">
                                    <i className="nav-icon fa fa-check" />
                                    <p>Paymode Wise</p>
                                </a>
                            </li> */}
                        </ul>
                    </nav>
                </div>
            </aside>
        </div>
    )
}
export default Reportmenu